module.exports = __webpack_public_path__ + "static/media/mxyl_swiper.3bcf9f1a.jpg";